import ENV from "config/Env";
import { typedQueryClient, usePermanentRealTimeUser, useTypedMutation } from "hooks";
import { useGetUnlinkedLicensesFilters } from "modules/UnlinkedExactLicensesDashboard/components/UnlinkedExactLicensesFilters/hooks";
import { UnlinkedExactLicensesQueryKeys } from "modules/UnlinkedExactLicensesDashboard/queryKeys";
import { ApiInstance } from "utils/Api";
import { toISOString } from "utils/dateHelperFunctions";

import type { EXACT_CATEGORIES, ExactCategory, ExactCategoryID, ROLES } from "models";

type UnlinkedExactLicensesPayload = {
  ignore: boolean;
  exact_category_id?: ExactCategoryID;
  role_id?: ROLES;
  exact_category_type?: EXACT_CATEGORIES;
  dealer_location_id?: number;
};

export const useIgnoreLicenseMutation = () => {
  const { user } = usePermanentRealTimeUser();
  const filters = useGetUnlinkedLicensesFilters();

  return useTypedMutation<UnlinkedExactLicensesPayload, ExactCategoryID>({
    mutationFn: async (payload: UnlinkedExactLicensesPayload) => (await ApiInstance.post("/licenses/ignore", payload, ENV.exactBaseURL)).data.exact_category_id,
    onSuccess: (payload, exact_category_id) => {
      const unlinkedExactCategories = typedQueryClient.getQueryData(UnlinkedExactLicensesQueryKeys.unlinkedExactCategories);
      if (!unlinkedExactCategories) return;

      const shouldFilterOut = filters.ignored !== null && filters.ignored !== payload.ignore;
      const exactCategoryIdx = unlinkedExactCategories.findIndex(ec => ec.id === exact_category_id);
      if (exactCategoryIdx === -1) return;

      let updatedCategories: ExactCategory[] = [];

      if (shouldFilterOut) updatedCategories = unlinkedExactCategories.toSpliced(exactCategoryIdx, 1);
      else
        updatedCategories = unlinkedExactCategories.with(exactCategoryIdx, {
          ...unlinkedExactCategories[exactCategoryIdx],
          ...payload,
          is_unlinked_license_ignored: payload.ignore,
          is_unlinked_license_ignored_updated_on: toISOString(new Date()),
          is_unlinked_license_ignored_updated_by: `${user?.first_name || ""} ${user?.last_name || ""}`
        });

      typedQueryClient.setQueryData(UnlinkedExactLicensesQueryKeys.unlinkedExactCategories, updatedCategories);
    }
  });
};
